export const GET_TEAM_OUTLET_PENDING = 'GET_TEAM_OUTLET_PENDING';
export const GET_TEAM_OUTLET_FULFILLED = 'GET_TEAM_OUTLET_FULFILLED';
export const GET_TEAM_OUTLET_REJECTED = 'GET_TEAM_OUTLET_REJECTED';

export default function reducer(state = {
  store: {},
  staff_members: [],
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case GET_TEAM_OUTLET_PENDING:
      return {
        ...state,
        store: {},
        staff_members: [],
        fetching: true,
        fetched: false,
        errors: {}
      };
    case GET_TEAM_OUTLET_FULFILLED:
      return {
        ...state,
        store: action.payLoad.data,
        staff_members: action.payLoad.data.relationships ? action.payLoad.data.relationships['staff-members'].data : [],
        fetching: false,
        fetched: true,
        errors: {}
      };
    default:
      return {
        ...state,
        errors: {}
      };
  }
}
